export default [
  {
    value: 5,
    label: 'Top 5 Results & Bottom 5 Results',
  },
  {
    value: 10,
    label: 'Top 10 Results & Bottom 10 Results',
  },
]



// WEBPACK FOOTER //
// ./src/data/top-bottom-filters.js